import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { TagErrorCode } from '~commonInfra/utils/ErrorCodes';
import {SessionSiteSelectors} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import {getAppStore} from '~src/bootstrap/redux/store/AppStore';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Messages } from '../../codegen/Localize';
import { SimulationContentType } from '../../spacesPlatform/models/ContentTypes';
import { ISimulationBase } from '../models/ISimulationInfo';

// TODO - Need to change when hooked up with backend services.
export enum SimulationErrorCode {
  SimulationNameAlreadyExistsInDestinationProject = -1,
  BadRequest = -2,
  SimulationNotFound = -3,
  InvalidRequest = -4,
  SimulationNameAlreadyExists = -5,
  InternalError = -6,
  ServiceUnavailable = -7,
  ServiceRequestFailed = -8
}

function errorDetailsFor(simulationErrorItem: IErrorItem<ISimulationBase>): IErrorDetail {
  return {
    itemName: simulationErrorItem.item.name,
    itemUrl:
        simulationErrorItem.error.code === SimulationErrorCode.SimulationNotFound
        ? null
        : ContentUrlForItem(simulationErrorItem.item, SimulationContentType),
    errorMessage: this.errorMessageFor(simulationErrorItem)
  };
}

function errorMessageFor(errorItem: IErrorItem<ISimulationBase>) {
  const simulation = errorItem.item;
  switch (errorItem.error.code) {
    case SimulationErrorCode.SimulationNotFound:
      return Messages.errorSimulationNotFound({SIMULATION_NAME: simulation.name});
    case SimulationErrorCode.SimulationNameAlreadyExistsInDestinationProject:
      return Messages.errorSimulationNameAlreadyExistsInDestinationProject();
    case TagErrorCode.TooManyTags:
      return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
    default:
      return Messages.errorUnknown();
  }
}

export const SimulationErrors = {
  errorDetailsFor,
  errorMessageFor
};
